import React, { useState } from "react";

import BackDrop from "../../../components/ui/BackDrop";
import { cn } from "../../../utils/twMerge";

import { datePickerIcon, closeIcon } from "../../../assetData/icons";
import { errorNotify } from "../../../Services/Notification";
import CustomDateInput from "../../../components/ui/custom-date-input/CustomDateInput";
import MirageLoader from "../../../components/ui/pageLoader/MirageLoader";

const MasterFinyearEditForm = ({
  finyearData,
  form,
  segmentName,
  editHandler,
  closeHandler,
  selectedItemId,
  isButtonClicked
}) => {
  const errors = form.formState.errors;

  const filteredData = finyearData?.filter(
    (item) => item.id !== selectedItemId,
  );
  const onSubmit = async (data) => {
    const duplicacyCheck = () => {
      const finyear = filteredData
        ?.map((item) => item.fin_year_name)
        .includes(data?.fin_year_name);
      const finyearShortName = filteredData
        ?.map((item) => item.fin_year_short_name)
        .includes(data?.fin_year_short_name);

      return { finyear, finyearShortName };
    };

    const { finyear, finyearShortName } = duplicacyCheck();

    if (finyear && finyearShortName) {
      errorNotify(
        "Entered Financial Year Name and Short Name is already present ",
      );
    } else if (finyear && !finyearShortName) {
      errorNotify("Entered Financial Year Name is already present ");
    } else if (!finyear && finyearShortName) {
      errorNotify("Entered Short Name is already present ");
    } else if (!finyear && !finyearShortName) {
      const statusValue = form.getValues("status") === "true";
      const updatedData = { ...data, status: statusValue };

      const res = await editHandler(selectedItemId, updatedData);
      if (res) closeHandler();
    }
  };

  const onClose = () => {
    closeHandler();
  };

  return (
    <>
      <div className="fixed left-1/2 z-50 mx-auto min-h-[300px] w-[98%] max-w-[1000px] -translate-x-1/2 rounded bg-white p-8 max-sm:top-[10%] sm:top-1/2 sm:-translate-y-1/2">
        <h2 className="pb-4 text-2xl font-bold text-neutral-800">{`Edit ${segmentName}`}</h2>

        <button
          type="button"
          className="absolute right-8 top-8"
          onClick={onClose}
        >
          <img src={closeIcon} />
        </button>

        <form onSubmit={form.handleSubmit(onSubmit)}>
          {/* row 1 */}
          <div className="gap-2 sm:flex max-sm:[&>div]:mt-4">
            <div className={cn("flex w-full flex-col  gap-2")}>
              <label className="text-base text-[#636363]">
                {segmentName} Name *
              </label>
              <input
                placeholder="Equity"
                {...form.register("fin_year_name")}
                className={cn(
                  "h-full rounded bg-neutral-100 p-2 px-2 text-[#636363] placeholder:italic focus:outline-none",
                  errors.fin_year_name && "border-[1px] border-red-300",
                )}
              />
            </div>

            <div className={cn("flex w-full flex-col  gap-2")}>
              <label className="text-base text-[#636363]">Short Name</label>
              <input
                placeholder="EQ"
                {...form.register("fin_year_short_name")}
                className={cn(
                  "h-full rounded bg-neutral-100 p-2 px-2 text-[#636363] placeholder:italic focus:outline-none",
                  errors.fin_year_short_name && "border-[1px] border-red-300",
                )}
              />
            </div>
            <div className={cn("flex w-full flex-col  gap-2")}></div>
          </div>

          {/* row 2 */}
          <div className="items-end gap-2 sm:flex">
            <div className="flex h-full  w-full flex-col gap-2">
              <label className="text-[#636363]">Status</label>
              <div
                className={cn(
                  " h-full rounded bg-neutral-100 px-2 py-[9px]",
                  errors.status && "border-[1px] border-red-300",
                )}
              >
                <select
                  {...form.register("status")}
                  className=" w-full  bg-transparent px-2 text-[#636363] focus:outline-none"
                  // defaultValue={true}
                >
                  <option value={true}>Active</option>
                  <option value={false}>Inactive</option>
                </select>
              </div>
            </div>

            <div className="flex w-full items-stretch gap-4 text-neutral-600 max-sm:mt-4 sm:mt-8">
              <div className="flex w-full  flex-col gap-2 ">
                <label>Start date *</label>

                <CustomDateInput
                  max={form.getValues("eff_end_date")}
                  initialValue={form.getValues("eff_start_date")}
                  handleSetValue={(val) => {
                    form.setValue("eff_start_date", val);
                    form.clearErrors("eff_start_date");
                  }}
                  className={cn(
                    " h-full w-full rounded bg-neutral-100 p-2 px-2 text-[#636363] focus:outline-none",
                    errors.eff_start_date && "border-[1px] border-red-300",
                  )}
                />
              </div>
            </div>

            <div className="flex w-full items-stretch gap-4 text-neutral-600 max-sm:mt-4 sm:mt-8">
              <div className="flex w-full  flex-col gap-2 ">
                <label>End date</label>

                <CustomDateInput
                  min={form.getValues("eff_start_date")}
                  initialValue={form.getValues("eff_end_date")}
                  handleSetValue={(val) => {
                    form.setValue("eff_end_date", val);
                    form.clearErrors("eff_end_date");
                  }}
                  className={cn(
                    " h-full w-full rounded bg-neutral-100 p-2 px-2 text-[#636363] focus:outline-none",
                    errors.eff_end_date && "border-[1px] border-red-300",
                  )}
                />
              </div>
            </div>
          </div>
          <div className="flex items-end justify-between sm:gap-2 sm:[&>button]:w-1/3">
            <button
              type="submit"
              disabled={isButtonClicked}
              className={` ${
                isButtonClicked ? "opacity-[70%]" : ""
              } mt-8 w-full rounded border-2 border-pri-clr-orange bg-pri-clr-orange px-2 py-2 font-semibold text-white `}
            >
              {isButtonClicked ? <MirageLoader /> : "SAVE CHANGES"}
            </button>
            <button></button>
            <button></button>
          </div>
        </form>
      </div>
      <BackDrop
      />
    </>
  );
};

export default MasterFinyearEditForm;
